import { isMarketSingle, dateToString } from '@/utils/helpers';
import criteriaIcon from '@/assets/icons/v2/rules-criteria.svg';
import datesIcon from '@/assets/icons/v2/rules-dates.svg';
import marketTypeIcon from '@/assets/icons/v2/rules-market-type.svg';

export default {
  data() {
    return {
      criteriaIcon,
      datesIcon,
      marketTypeIcon,
    };
  },
  props: {
    market: {
      type: Object,
      required: true,
    },
  },
  computed: {
    rulesModel() {
      return (this.market && this.market.rulesModel) || {};
    },
    startDate() {
      return this.rulesModel.dateStart
        ? dateToString(this.rulesModel.dateStart)
        : null;
    },
    endDate() {
      const text = this.rulesModel.dateEndText;

      if (text && text.toUpperCase() === 'NA') {
        return null;
      }

      if (!text || text.trim() === '') {
        return this.rulesModel.dateEnd
          ? dateToString(this.rulesModel.dateEnd)
          : null;
      }

      return text.trim();
    },
    isMarketSingle() {
      return isMarketSingle(this.market);
    },
    clarificationDisclaimer() {
      return (this.rulesModel.ruleClarifications || [])
        .find(clarification => clarification.isHighlighted);
    },
    clarificationsSection() {
      return this.rulesModel.ruleClarifications || [];
    },
  },
  methods: {
    dateToString,
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-rules-content/market-rules-content.js